import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import toMessageText from '../messageText';

export default function ErrorMessage({ message, show, setShow }) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setShow(false);
  };

  return (
    <Snackbar
      open={show}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={8000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        variant="outlined"
        severity="error"
        sx={{
          width: '100%',
          backgroundColor: 'background.paper',
        }}
      >
        <p className="mb-0">{toMessageText(message, 'Ocorreu um erro inesperado.')}</p>
      </Alert>
    </Snackbar>
  );
}
